module.exports = __webpack_public_path__ + "images/first-time-mover.bfdab7c448df1efd629741e2dc60f8b1.svg";